import React, { Component } from 'react';
import Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);
import { getMapData } from '../../../api'

class MapChartDirect extends Component {
	 
	constructor(props) {
		super(props);
		
		this.handleSelect = this.handleSelect.bind(this)
		this.state ={
			firstLoad: true,
			chartConfig: {
				chart: {
					map: require('../../../model/map.europe.geo.json'),
					spacingBottom: 20,
					height: 800,
					width: 1024,
					backgroundColor: '#F0F0F0'
				},
				
                title: {
					text: this.props.title
				},

				tooltip: {
					enabled: false
				},

				credits: {
					enabled: false
				},
				
				exporting: {
					enabled: false,
					y:-10,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
					chartOptions:
					{
						credits: {
							enabled: true
						}
					}
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 4
					}
				},
				legend: {
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					y: 45,
				},
				colorAxis: {
					type: 'linear',
					minColor: '#dcecec',
                    maxColor: '#4a8e91',
					stops: [
                        [0, '#DAEBEC'],
                        [0.5, '#B4D6D7'],
                        [1,'#4a8e91'],
                    ],
					tickPixelInterval: 100
				},
				plotOptions: {
					map: {
                        nullColor: '#F0F0F0',
                        dataLabels: {
                            enabled: true,
                            color: '#000',
                            style: {
                                textShadow: false, 
                                textOutline: "#c7e2e3",
                                fontFamily: 'OpenSans-Bold',
                                fontSize:'14px'
                            },
                            formatter: function () {
                                if (this.point.value) {
                                    if(this.point["hc-key"] === "gr"){
                                        return "EL";
                                    }else if(this.point["hc-key"] === "gb"){
                                        return "UK";
                                    }else if(this.point["hc-key"] === "hr"){
                                        this.point.properties['hc-middle-x'] = 0.50
                                        this.point.properties['hc-middle-y'] = 0.20
                                        return "HR";
                                    }else if(this.point["hc-key"] === "nl"){
                                        if(window.innerWidth < 425){
                                            this.point.properties['hc-middle-x'] = 0.70
                                            this.point.properties['hc-middle-y'] = 0.20
                                        }else{
                                            this.point.properties['hc-middle-x'] = 0.60
                                            this.point.properties['hc-middle-y'] = 0.50
                                        }
                                        return "NL";
                                    }else if(this.point["hc-key"] === "mt"){
                                        this.point.properties['hc-middle-y'] = -0.95;
                                        return "MT";
                                    }else{
                                        return this.point["hc-key"].toUpperCase();
                                    }
                                }
                            }
                        }
                    },
					series: {
						allowPointSelect: true,
						cursor: 'pointer',
						borderColor: '#c4c4c4',
						borderWidth: 2,
						states:{
							hover: {
								enabled: true,
								borderColor: '#57575A',
							},
							select: {
								color: '#f6a400'
							}
						},
						point: {
							events: {
								click: this.countrySelect = (e) =>  {
									let countryCode = e.point["hc-key"].toUpperCase();
                                    if (countryCode == "GR")
                                    {
                                        countryCode = "EL";
                                    }
                                    this.handleSelect(countryCode);
								}
							}
						}
					}
				},			
				series: []
			}
		}	
	}

    handleSelect = (pCountryCode) =>{
        const {handleMapClick}= this.props
        handleMapClick(pCountryCode)
    }

	toggleLoad()
	{
		this.setState( { firstLoad: false } );
	}

    loadData()
    {
        getMapData(this.props.chartID, this.props.indicatorID)
            .then((res) => {
                let series = [];

                let seriesObject = { name: '', data: res.resultset.seriesData }
                // let patternObject = { name: '', data: res.resultset.patternData }

                series.push(seriesObject);
                // series.push(patternObject);

                this.setState({ chartConfig: {...this.state.chartConfig, title: { text: this.props.title }, series }})
            })
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.indicatorID != this.props.indicatorID || prevState.firstLoad != this.state.firstLoad)
        {
            this.loadData();
        }

        if (prevProps.selectedCountry != this.props.selectedCountry && this.props.selectedCountry.length == 0)
        {
            // Remove the selection from the chart
			const chartIndex = Highcharts.charts.length - 1;
			if (Highcharts.charts[chartIndex] != undefined)
			{
				const selectedPoints = Highcharts.charts[chartIndex].getSelectedPoints();
            	selectedPoints.forEach((point) => point.select());
			}
        }
    }

    componentDidMount()
    {
        this.loadData();
    }

	render()
	{
		if (this.state.firstLoad)
		{
			this.toggleLoad();
		}
		return(
			<div>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.state.chartConfig}
					constructorType='mapChart'
				/>
			</div>
		);
	}
}

export default MapChartDirect;
